export default __webpack_public_path__ + "static/media/avatar_bg_naruto.b4c221af.png";